import axios from 'axios'
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
const api = '/api/'

export const classRoomsList = createAsyncThunk(
  'school/class-room-list',
  async (params: any, thunkAPI) => {
    try {
      const { data } = await axios.get(`${api}class-room/list`, params)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const getSchoolSessions = createAsyncThunk(
  'school/get-school-sessions',
  async (_, thunkAPI) => {
    try {
      const { data } = await axios.get(`${api}class-room/get-school-sessions`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const getSchoolClasses = createAsyncThunk(
  'school/get-school-classes',
  async (_, thunkAPI) => {
    try {
      const { data } = await axios.get(`${api}class-room/get-school-classes`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const classRoomStore = createAsyncThunk(
  'school/class-room-store',
  async (classRoomData: any, thunkAPI) => {
    try {
      const { data } = await axios.post(`${api}class-room/store`, classRoomData)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const classRoomEdit = createAsyncThunk(
  'school/class-room-edit',
  async (id: any, thunkAPI) => {
    try {
      const { data } = await axios.get(`${api}class-room/edit/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const classRoomSwitchStatus = createAsyncThunk(
  'school/class-room-switch-status',
  async (id: any, thunkAPI) => {
    try {
      const { data } = await axios.get(`${api}class-room/switch-status/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const classRoomView = createAsyncThunk(
  'school/class-room-view',
  async (id: any, thunkAPI) => {
    try {
      const { data } = await axios.get(`${api}class-room/view/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const getSchoolSubjects = createAsyncThunk(
  'school/get-school-subjects',
  async (id: any, thunkAPI) => {
    try {
      const { data } = await axios.get(`${api}class-room/get-school-subjects/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const getSchoolDays = createAsyncThunk('school/get-school-days', async (_, thunkAPI) => {
  try {
    const { data } = await axios.get(`${api}class-room/get-school-days`)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const getSchoolHours = createAsyncThunk('school/get-school-hours', async (_, thunkAPI) => {
  try {
    const { data } = await axios.get(`${api}class-room/get-school-hours`)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const getClassRoomSchedules = createAsyncThunk(
  'school/get-class-room-schedules',
  async (id: any, thunkAPI) => {
    try {
      const { data } = await axios.get(`${api}class-room/get-schedules/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const getCheckAllProgress = createAsyncThunk(
  'school/get-check-all-progress',
  async (id: any, thunkAPI) => {
    try {
      const { data } = await axios.get(`${api}class-room/get-check-all-progress/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const classRoomScheduleStore = createAsyncThunk(
  'school/class-room-schedule-store',
  async (scheduleData: any, thunkAPI) => {
    try {
      const { data } = await axios.post(`${api}class-room/store-schedule`, scheduleData)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

export const classRoomScheduleEdit = createAsyncThunk(
  'school/class-room-schedule-edit',
  async (id: any, thunkAPI) => {
    try {
      const { data } = await axios.get(`${api}class-room/edit-schedule/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const classRoomScheduleDelete = createAsyncThunk(
  'school/class-room-schedule-delete',
  async (id: any, thunkAPI) => {
    try {
      const { data } = await axios.get(`${api}class-room/delete-schedule/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const classRoomScheduleApprove = createAsyncThunk(
  'school/class-room-schedule-approve',
  async (id: any, thunkAPI) => {
    try {
      const { data } = await axios.get(`${api}class-room/approve-schedule/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const classRoomSchedulePrint = createAsyncThunk(
  'school/class-room-schedule-print',
  async (id: any, thunkAPI) => {
    try {
      const { data } = await axios.get(`${api}class-room/print-schedule/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const getLecturers = createAsyncThunk(
  'school/get-lecturers',
  async (_, thunkAPI) => {
    try {
      const { data } = await axios.get(`${api}class-room/get-lecturers`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const getSchoolAcademicYear = createAsyncThunk(
  'school/get-school-academic-year',
  async (_, thunkAPI) => {
    try {
      const { data } = await axios.get(`${api}class-room/get-school-academic-year`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const GetClassRoomsByYear = createAsyncThunk('get-class-rooms-by-academic-year', async (params: {}, thunkAPI) => {
  try {
    const { data } = await axios.get(`${api}class-room/get-class-rooms-by-academic-year`, params)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const GetSubjectClassRoom = createAsyncThunk('get-subject-class-room', async (params: {}, thunkAPI) => {
  try {
    const { data } = await axios.get(`${api}class-room/get-subject-class-room`, params)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

type ClaaRoomState = {
  errors: any
}

const initialState: ClaaRoomState = {
  errors: '',
}

export const classRoomSlice = createSlice({
  name: 'class-room',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(classRoomStore.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
    builder.addCase(classRoomScheduleStore.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
  },
})

export const { reset } = classRoomSlice.actions
export default classRoomSlice.reducer
